// Port of api/fuel/app/classes/controller/api/monty/session/early.php
import DB from 'offline/db'
import PlatformEarly from 'offline/model/platform/early'

function userId(params) {
	return params.sessionUserId || DB.meta('sync_user_id') || false
}

function adoptedSlugs(uid) {
	var rows = DB.query('SELECT early_slug, early_adopted FROM platform_early')
	var access = []

	for (var i = 0; i < rows.length; i++) {
		var adopted = rows[i].early_adopted || []
		if (typeof adopted === 'string') {
			try { adopted = JSON.parse(adopted) } catch (e) { adopted = [] }
		}
		if (!Array.isArray(adopted)) adopted = []
		if (adopted.indexOf(String(uid)) !== -1 || adopted.indexOf(parseInt(uid, 10)) !== -1) {
			access.push(rows[i].early_slug)
		}
	}

	return access
}

function itemArray(item) {
	return {
		id: parseInt(item.early_id, 10),
		name: item.early_name,
		slug: item.early_slug,
		url: item.early_url,
		status: parseInt(item.early_status, 10),
		description: item.early_description,
		date: {
			added: parseInt(item.early_date_added || 0, 10),
			live: parseInt(item.early_date_live || 0, 10)
		},
		image: item.early_image
	}
}

export default function(params) {
	var method = params.__offlineMethod || 'GET'
	var uid = userId(params)

	if (!uid) {
		return Promise.reject({ error: 'Not available offline without a local session.', offline: true })
	}

	if (method === 'GET') {
		var items = DB.query(
			'SELECT * FROM platform_early WHERE early_status < 3 ORDER BY early_status ASC, early_name ASC'
		).map(itemArray)

		return Promise.resolve({
			session: { offline: true },
			data: {
				items: items
			}
		})
	}

	if (method === 'POST') {
		var early = PlatformEarly.with_id(params.id)
		if (!early) {
			return Promise.reject({ error: 'Invalid early access item', offline: true })
		}

		var adopted = early.get_adopted() || []
		var idString = String(uid)
		var next = []
		var found = false

		for (var i = 0; i < adopted.length; i++) {
			if (String(adopted[i]) === idString) {
				found = true
			} else {
				next.push(adopted[i])
			}
		}

		if (!found) next.push(idString)

		DB.run('UPDATE platform_early SET early_adopted = ? WHERE early_id = ?', [JSON.stringify(next), early.get_id()])
		return DB.save().then(function() {
			return {
				session: { offline: true },
				data: {
					early: adoptedSlugs(uid)
				}
			}
		})
	}

	return Promise.reject({ error: 'This action is not available offline.', offline: true })
}
